import {store} from '../store.index';
import { observable, action } from 'mobx';
import { openShare, docCoordinationShareUserList, addCollaborator, checkSharePwd, getDocShare } from '@/api/fwApi/sharecollaboration';
// import { downloadURL } from '@/api/fwApi/docs';
import { collaborationMqttService } from 'Store/services/index'

class shareCollaboration {
  @observable shareInfo = {};
  @observable cloudShareStart = false;
  @observable cloudShareType = ""; // 用于处理页面显示：showLogin——提示登录；showNoAuth——提示无权限；showNoShare——提示分享已取消;showCheckDrawCode——验证提取码
  @observable shareUserList = {}; // 加入分享用户列表
  @observable shareUserType = ""; // 分享未创建时为空，同时用于区分是企业用户协同分享还是普通协同分享； joinShareUser——加入分享； createShareUser——创建分享
  @observable noCollaborationToShare = false; // 用于判断企业用户文档是否有协同分享的权限
  @observable isLoginInterval = false;
  @observable isOpenOtherShare = false; // 用于判断是否是打开了别人的共享链接
  
  @action setIsLoginInterval = (val) => {
    this.isLoginInterval = val;
  }
  @action setIsOpenOtherShare = (val) => {
    this.isOpenOtherShare = val;
  }
  @action setNoCollaborationToShare = (val) => {
    this.noCollaborationToShare = val;
  }
  @action setShareInfo = (val) => {
    if(val && !val.shareId) {
      val.shareId = val.id
    }
    if(val.shareUrl.includes("/cloudShare/") && !val.shareUrl.includes("/#/cloudShare")) {
      let urlArr = val.shareUrl.split("/cloudShare/")
      val.shareUrl = `${urlArr[0]}/#/cloudShare/${urlArr[1]}`
    }
    val.shareValueType = val.aclScope==1 ? "appointorShare" : (val.acl==0 ? "publicShow": "publicAnnot")
    val.isEncrypted = val.drawCode ? 1 : 0
    this.shareInfo = val
  }
  @action resetShareCollaboration =() => {
    this.shareInfo={}
    this.cloudShareType = ""
    this.shareUserList = "",
    this.shareUserType = ""
  }
  @action setCloudShareStart = (val) => {
    this.cloudShareStart = val
  }
  @action setCloudShareType = (val) => {
    this.cloudShareType = val
  }
  @action setShareUserList = (val) => {
    this.shareUserList = val
  }
  @action setShareUserType = (val) => {
    this.shareUserType = val
  }
  // 打开分享链接获取分享信息
  @action openShareCollaboration = (code) => {
    return openShare({params:{code}}).catch(err => {
      console.log(err)
    })
  }
  // 获取分享用户列表
  @action getDocCoordinationShareUserList = () => {
    const { shareDocsInfo } = store.shareStore
    const shareId = this.shareInfo.shareId || shareDocsInfo.shareId
    return docCoordinationShareUserList({params:{ shareId }}).catch(err => {
      console.log(err)
    })
  }
  // 获取用户列表并保存
  @action getDocCoordinationShareUserListAndSaveList = async () => {
    let result = await this.getDocCoordinationShareUserList()
    if(result && result.code == 0) {
      this.setShareUserList(result.data)
    }
  }
  // 添加用户
  @action addCollaboratorUser = (userItem, urlJoin) => {
    const { shareDocsInfo } = store.shareStore
    const shareInfo = this.shareInfo || shareDocsInfo
    let config = {
      params: {
        acl: shareInfo.acl,
        joinDesc: urlJoin ? "链接访问": "直接指定添加",
        nickName: userItem.nickName || userItem.nickname,
        shareId: shareInfo.shareId || shareInfo.id,
        userId: userItem.userId,
        avatar: userItem.figure
      }
    }
    return addCollaborator(config).catch(err => {
      console.log(err)
    })
  }
  // 验证密码
  @action checkSharePwdShare = (drawCode) => {
    const { shareDocsInfo } = store.shareStore
    return checkSharePwd({params: {drawCode, shareId: shareDocsInfo.shareId }}).catch(err => {
      console.log(err)
    })
  }
  // 下载分享文件并打开
  @action downloadURLAndOpenFile = () => {
    // let config = {
    //   headers: {
    //     appKey: store.docsStore.appKey
    //   },
    //   params: {
    //     docId: this.shareInfo.docId,
    //     token: store.userNewStore.userToken
    //   }
    // }
    const reviewSessionID = store.collaborationStore.reviewSessionID;
    const url = `https://webpdfapi.foxitcloud.cn/v1/api/doc/downloadFile?docId=${this.shareInfo.docId}&plateform=pc&token=${store.userNewStore.userToken}`
      store.openUrlFileStore.openUrlFile(encodeURIComponent(url))
      store.collaborationStore.confirmInvitation(reviewSessionID).then(res => {
        // store.appStore.viewerEventEmitter.emit('changeToolBar', 'collaboration');
        if(res.ret === 110015) {
          const search = window.location.search;
          if(search){
            window.history.pushState({},'','/')
          }
          store.appStore.backToHomeStart();
          message.error(intl.get("collaboration.Error.limitOnJoin"));
          return Promise.reject('limit on join')
        }
      })

    // downloadURL(config).then(res => {
    //   if(res.code === 0) {
    //     store.collaborationStore.setFwBeginShare(true)
    //     const reviewSessionID = store.collaborationStore.reviewSessionID;
    //     store.openUrlFileStore.openUrlFile(encodeURIComponent(res.data.downloadURL))
    //     store.collaborationStore.confirmInvitation(reviewSessionID).then(res => {
    //       if(res.ret === 110015) {
    //         const search = window.location.search;
    //         if(search){
    //           window.history.pushState({},'','/')
    //         }
    //         store.appStore.backToHomeStart();
    //         message.error(intl.get("collaboration.Error.limitOnJoin"));
    //         return Promise.reject('limit on join')
    //       }
    //     })
    //   } else {
    //     if(res.code === 401) { // 认证失败
    //       store.saveFileNewStore.setIsShowFwDocsIframe(true)
    //       setTimeout(() => {
    //         store.saveFileNewStore.setIsShowFwDocsIframe(false)
    //         this.downloadURLAndOpenFile(this.shareInfo.docId)
    //       }, 500)
    //     } else {
    //       store.shareCollaborationStore.setCloudShareType("showNoShare")
    //     }
    //   }
    // })
  }
  // 获取分享文件信息 
  @action getDocShare = async () => {
    return getDocShare({params: {docId: this.shareInfo.docId}}).catch(err => console.log(err))
  }
  // joinshare 首页进入分享后的验证
  @action joinShare = async () => {
    let shareInfo = this.shareInfo
    let { userData } = store.userNewStore
    let hasAuth = false
    let isCreator = false
    // 获取当前已加入的用户列表
    let userListResult = await this.getDocCoordinationShareUserList()
    if(userListResult && userListResult.code === 0) {
      let userList = userListResult.data
      this.setShareUserList(userList)
      userList.forEach(item => {
        if(item.userId == userData.userId) {
          hasAuth = true
          if(item.creatorFlag == 1) {
            isCreator = true
            this.setShareUserType("createShareUser")
          }
        }
      })
    }
    if(shareInfo && shareInfo.aclScope == 1) { // 部分人员，获取列表，是否有当前用户
      if(hasAuth) { // 有权限，
        if (shareInfo.drawCode === "true" || isCreator) { // 无需校验密码
          // 加入协同并打开文档
          this.downloadURLAndOpenFile()
        } else {
          this.setCloudShareType("showCheckDrawCode")  // 显示密码弹窗
        }
      } else { // 无权限
        this.setCloudShareType("showNoAuth")
      }
    } else if (shareInfo && shareInfo.aclScope == 0) { // 所有人均可加入
      if(hasAuth) { // 有权限
        if (shareInfo.drawCode === "true" || isCreator) { // 无需校验密码、或当前为分享人打开
          // 加入协同并打开文档
          this.downloadURLAndOpenFile()
          // 这里有权限不需要再次添加协作者。
        } else {
          this.setCloudShareType("showCheckDrawCode")  // 显示密码弹窗
        }
      } else { // 无权限
        if (shareInfo.drawCode === "true") { // 无需校验密码
          // 加入协同并打开文档
          this.downloadURLAndOpenFile()
          // 将用户加入
          let result = await this.addCollaboratorUser(userData, true)
          if(result && result.code === 0) {
            setTimeout(() => {
              collaborationMqttService.publish("addCollaboratorUser") // 触发mqtt通信
            }, 5000)
            // this.getDocCoordinationShareUserListAndSaveList()
          }
        } else {
          this.setCloudShareType("showCheckDrawCode")  // 显示密码弹窗
        }
      }
    }
  }
}
export default shareCollaboration